export default [
  {
    id: 1,
    type: 1,
    name: 'Business Consulting Dept'
  },
  {
    id: 2,
    type: 2,
    name: 'Project Management Dept'
  },
  {
    id: 3,
    type: 3,
    name: 'Administrative Dept'
  },
  {
    id: 4,
    type: 4,
    name: 'Sales Department'
  },
  {
    id: 5,
    type: 5,
    name: 'Marketing Department'
  }
]



// WEBPACK FOOTER //
// ./src/constants/departmentsTypes.js